import { toKebabCase } from '../utils/toKebabCase';

import AdAnalysis from './Report/AdAnalysis';
import SiteAnalysis from './Report/SiteAnalysis';
import SearchAnalysis from './Report/SearchAnalysis';
import CreativeAnalysis from './Report/CreativeAnalysis';
import DataTable from './Report/DataTable';
import ReportOutput from './Report/ReportOutput';
import ReportPreview from './Report/ReportPreview';
import Contact from './Contact';
import ContactThanks from './ContactThanks';
import PreRegisterThanks from './PreRegisterThanks';
import ActionHistory from './ActionHistory';
import SettingAccountProfile from './AccountSetting/Profile';
import SettingAccountCorporate from './AccountSetting/Corporate';
import SettingAccountPlan from './AccountSetting/Plan';
import SettingProjectBudget from './ProjectSetting/Budget';
import SettingProjectExternal from './ProjectSetting/External';
import SettingProjectPreference from './ProjectSetting/Preference';
import Board from './Board';

const pageModules = require.context('./', false, /\.tsx$/);

const routes = pageModules.keys().map((path) => {
  const name = path.replace('./', '').replace('.tsx', ''); // "HomePage" 等
  let routePath = '';
  switch (name) {
    case 'Top':
      routePath = '/';
      break;
    case 'Board':
      routePath = '/board/:chatId?';
      break;

    default:
      routePath = `/${toKebabCase(name)}`; // ケバブケースに変換 (ActionHistory -> action-history)
      break;
  }
  return {
    path: routePath,
    Component: pageModules(path).default,
  };
});

// Add Report routes manually
routes.push(
  { path: '/report', Component: AdAnalysis },
  { path: '/report/site', Component: SiteAnalysis },
  { path: '/report/search', Component: SearchAnalysis },
  { path: '/report/creative', Component: CreativeAnalysis },
  { path: '/report/data', Component: DataTable },
  { path: '/report/export', Component: ReportOutput },
  { path: '/report/preview', Component: ReportPreview },
  { path: '/action-history', Component: ActionHistory },
  { path: '/contact', Component: Contact },
  { path: '/contact/thanks', Component: ContactThanks },
  { path: '/pre-register/thanks', Component: PreRegisterThanks },
  { path: '/account-setting/profile', Component: SettingAccountProfile },
  { path: '/account-setting/corporate', Component: SettingAccountCorporate },
  { path: '/account-setting/plan', Component: SettingAccountPlan },
  { path: '/project-setting/budget', Component: SettingProjectBudget },
  { path: '/project-setting/preference', Component: SettingProjectPreference },
  { path: '/project-setting/external', Component: SettingProjectExternal }
);

export default routes;
